<template>
  <div v-if="!isMobile" class="qr-code">
    <div class="container">
      <div class="content">
        <h1>
          <img src="@/assets/images/top/logo_keimaki.png" alt="身のまわりにかくれている微生物を探しだせ！ タッチ de びせいぶつ狩り">
        </h1>
        <h2>スマートフォンやタブレットからアクセスしてね！</h2>
        <canvas id="qr" class="qr"></canvas>
        <p>※二次元バーコードをカメラアプリで撮影してください。</p>
      </div>
    </div>
  </div>
</template>

<script>
import AFRAME from 'aframe';
import { ref, onMounted } from 'vue';
import QRious from 'qrious';

export default {
  name: 'QRCode',
  components: {
  },
  props: {
  },
  setup(props, context) {
    const isMobile = ref(AFRAME.utils.device.isMobile());
    // console.log(isMobile.value);

    onMounted(() => {
      const qr = new QRious({
        element: document.getElementById('qr'),
        value: location.href,
        size: window.innerHeight / 5,
      });

    });

    return {
      isMobile
    }
  },
}
</script>

<style scoped lang="scss">
.qr-code {
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-image: url(~@/assets/images/top/bg_top.png);
  background-size: cover;
  .container {
    position: relative;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    padding: 5%;
    background-image: url(~@/assets/images/top/background_biseibutsu.png);
    background-size: cover;
  }
  .content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 600px;
  }
  h1 {
    width: 400px;
    margin: 0 auto;
  }
  h2 {
    font-size: 1.5rem;
    color: white;
  }
  p {
    font-size: 1rem;
    font-weight: bold;
    color: white;
  }
}
</style>